import { BrandDetails } from "../../types/brand";

// The brand routes remount BrandProvider on every navigation (the layout route
// is keyed by pathname). This module-level cache, tagged by auth token, lets a
// remounted provider — and pre-provider surfaces like the auth-check loading
// screen — render the last known brand identity immediately.
let cachedBrandDetails: BrandDetails | null = null;
let cachedForToken: string | null = null;

export function setCachedBrandDetails(details: BrandDetails | null): void {
  cachedBrandDetails = details;
  cachedForToken = details ? localStorage.getItem("brand_token") : null;
}

export function getCachedBrandDetails(): BrandDetails | null {
  const token = localStorage.getItem("brand_token");
  return token && token === cachedForToken ? cachedBrandDetails : null;
}
